import { __extends } from "tslib";
import React from "react";
import { Image, View } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacMessageImage.styles.js";
var PnmacMessageImage = /** @class */function (_super) {
  __extends(PnmacMessageImage, _super);
  function PnmacMessageImage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacMessageImage.prototype.render = function () {
    return /*#__PURE__*/React.createElement(View, {
      testID: "msgImage",
      style: [styles.container, this.props.containerStyle]
    }, /*#__PURE__*/React.createElement(Image, {
      style: [styles.image],
      source: {
        uri: this.props.currentMessage.image
      }
    }));
  };
  return PnmacMessageImage;
}(React.Component);
PnmacMessageImage.defaultProps = {
  currentMessage: {
    image: null
  },
  containerStyle: {}
};
PnmacMessageImage.propTypes = {
  currentMessage: PropTypes.object,
  containerStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};
export default PnmacMessageImage;